import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TranslocoService} from "@ngneat/transloco";

@Component({
  selector: 'app-table-section-header',
  templateUrl: './table-section-header.component.html',
  styleUrls: ['./table-section-header.component.scss']
})
export class TableSectionHeaderComponent {
  @Input() title: String | undefined;
  @Output() onExportToPDF = new EventEmitter<void>();

  constructor(public translocoService: TranslocoService) {
  }

  exportToPDF() {
    this.onExportToPDF.emit();
  }
}
